// Invoke strict mode
"use strict";

/**
 * Object of DOM element references for the UI.
 *
 * @object ui
 */
var ui = {};

/**
 * Main object to namespace all application logic.
 *
 * @object rgc
 */
var rgc = {

  /**
   * Application-wide reference to events.
   *
   * @property rgc.events
   */
  events: new Events(),

  /**
   * Method to handle app initialization.
   *
   * @method rgc.init
   */
  init: function() {

    // Fire the event to initialize the blocks
    rgc.events.emit("rgc.blocks.init");

  },

};

// Bind the app initialization to the DOM content loaded event
window.addEventListener("DOMContentLoaded", rgc.init.bind(rgc));

// Google Tag Manager
(function(w, d, s, l, i) {
  w[l] = w[l] || [];
  w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
  var f = d.getElementsByTagName(s)[0];
  var j = d.createElement(s);
  var dl = l != "dataLayer" ? "&l=" + l : "";
  j.async = true;
  j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
  f.parentNode.insertBefore(j, f);
})(window, document, "script", "dataLayer", "GTM-5PFP5WG");
